




import VueOptions from '@utils/VueOptions'

settings =
  vue: 
    beforeMount: -> @logout()
export default VueOptions.vue settings
